import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'ContentHeader',
  props: {
    wide: { type: Boolean }
  },
  setup(__props: any) {



return { __sfc: true, }
}

})